<template>
    <main class="fetchError">
        <Heading :h="1"
            size="s">
            {{ heading }}
        </Heading>
        <p class="error">
            {{ text }}
        </p>
        <Button
            url="/"
            prefixIcon="home"
            size="small">
            {{ siteContent.homepage }}
        </Button>
    </main>
</template>

<script>
    export default {
        name: 'FetchError',
        props: {
            heading: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>

    .h1 {
        text-align: center;
    }

    .fetchError {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 32rem;
        padding: 2rem;
    }

    .error {
        margin: 0 0 4rem 0;
        text-align: center;
    }
</style>